<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body">
            <div id="transaction_chart" style="height: 200px;"></div>
        </div>
        <kt-button
                class="m-2 ml-auto"
                size="md"
                variant="success"
                type="button"
                id="export_btn"
                @click="exportToExcel"
        >
            {{ $t('btn.export_transaction_to_excel') }}
        </kt-button>
    </div>
</template>

<script>
import jQuery from 'jquery'
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import 'jquery-flot'
import { i18n } from '@/plugins/i18n'
import axios from 'axios';

export default {
    name: 'monthly_transaction_chart',

    props: {
        chart_data: {
            default() {
                return {}
            }
        },
    },
    mounted() {
        let $this = this
        var KTFlotchartsDemo = function() {
            var demo2 = function() {
                var succeeded = $this.chart_data.succeeded;
                var failed = $this.chart_data.failed;

                var plot = $.plot($("#transaction_chart"), [{
                    data: failed,
                    label: i18n.t('dashboard.label.failed'),
                    lines: {
                        lineWidth: 1,
                    },
                    shadowSize: 0
                }, {
                    data: succeeded,
                    label: i18n.t('dashboard.label.succeeded'),
                    lines: {
                        lineWidth: 1,
                    },
                    shadowSize: 0

                }], {
                    series: {
                        lines: {
                            show: true,
                            lineWidth: 2,
                            fill: true,
                            fillColor: {
                                colors: [{
                                    opacity: 0.01
                                }, {
                                    opacity: 0.05
                                }]
                            }
                        },
                        points: {
                            show: true,
                            radius: 3,
                            lineWidth: 1
                        },
                        shadowSize: 2
                    },
                    grid: {
                        hoverable: true,
                        clickable: true,
                        tickColor: "#eee",
                        borderColor: "#eee",
                        borderWidth: 1
                    },
                    colors: ['red', 'darkgreen'],
                    xaxis: {
                        ticks: $this.chart_data.axis,
                        tickDecimals: 0,
                        tickColor: "#eee"
                    },
                    yaxis: {
                        ticks: 11,
                        tickDecimals: 0,
                        tickColor: "#eee",
                    }
                });

                function showTooltip(x, y, contents) {
                    $('<div id="tooltip">' + contents + '</div>').css({
                        position: 'absolute',
                        display: 'none',
                        top: y + 5,
                        left: x + 15,
                        border: '1px solid #333',
                        padding: '4px',
                        color: '#fff',
                        'border-radius': '3px',
                        'background-color': '#333',
                        opacity: 0.80
                    }).appendTo("body").fadeIn(200);
                }

                var previousPoint = null;
                $("#transaction_chart").bind("plothover", function(event, pos, item) {
                    $("#x").text(pos.x.toFixed(2));
                    $("#y").text(pos.y.toFixed(2));

                    if (item) {
                        if (previousPoint != item.dataIndex) {
                            previousPoint = item.dataIndex;

                            $("#tooltip").remove();
                            var x = $this.chart_data.axis[item.dataIndex][1],
                                y = item.datapoint[1].toFixed(2);

                            showTooltip(
                                item.pageX,
                                item.pageY,
                                i18n.t('label.transactions_of') + " "
                                + item.series.label + " "
                                + i18n.t('label.day') + " "
                                + parseInt(x) + " "
                                + i18n.t('label.th') + "<br>"
                                + i18n.t('label.total') + " : "
                                + formatter(parseInt(y)) + " "
                                + i18n.t('currency.rial') + "<br>"
                                + i18n.t('label.transaction_count') + " : "
                                + getCount(item.dataIndex, item.seriesIndex)
                            );
                        }
                    } else {
                        $("#tooltip").remove();
                        previousPoint = null;
                    }
                });
            }
            return {
                init: function() {
                    demo2();
                }
            };
        }();

        String.prototype.splice = function(idx, rem, str) {
            return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
        };
        
        function getCount(index, seriesIndex) {
            if (seriesIndex === 1) {
                return  $this.chart_data.succeeded_count[index]
            } else {
                return  $this.chart_data.failed_count[index]
            }
        }

        function formatter(amount) {
            amount = amount.toString()
            let length = amount.length;
            let offset = length % 3;
            if (offset === 0) offset = 3;
            let count = Math.floor((length - 1) / 3);
            for (let i = 0; i<count; i++){
                let pos = i * 3 + offset + i;
                amount = amount.splice(pos, 0, ',');
            }

            return amount
        }

        jQuery(document).ready(function() {
            setTimeout(function(){ KTFlotchartsDemo.init(); }, 2000);
        });
    },
    methods: {
        exportToExcel(){
            axios({
                url: ApiUrl.path('dashboard/transaction-excel'),
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'transactions.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });

        }
    }
}
</script>

<style>
    #tooltip {
        z-index: 100!important;
    }
    #kt_body > :first-child{
        z-index: initial !important;
    }
    .legend {
        position: absolute;
        bottom: 0;
    }
</style>